/* Mega Menu – mobile interactions */

const MOBILE_BREAKPOINT = 1199;

const BACK_BUTTON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="13.414" height="13.414" viewBox="0 0 13.414 13.414">
  <path id="ico_strzalka_menu_w_lewo" data-name="ico strzalka menu w lewo" d="M11.293,17.293l1.414,1.414L19.414,12,12.707,5.293,11.293,6.707,15.586,11H6v2h9.586Z" transform="translate(19.414 18.707) rotate(180)" fill="#0c0e1c"/>
</svg>`;

document.addEventListener('DOMContentLoaded', function () {
  initMobileMenu();
  initMobileMegaMenu();
});

function createBackButton(ariaLabel, onClick) {
  const backButton = document.createElement('button');
  backButton.className = 'mobile-menu__back';
  backButton.setAttribute('aria-label', ariaLabel);
  backButton.innerHTML = BACK_BUTTON_SVG;
  backButton.addEventListener('click', onClick);
  return backButton;
}

function resetPanelState(mobileMenu) {
  mobileMenu.querySelectorAll('.first-level-sub-menu, .ilabs-mega-menu-container').forEach(function (el) {
    el.classList.remove('submenu--active');
  });

  const mainNav = mobileMenu.querySelector('.mobile-menu__nav');
  if (mainNav) mainNav.classList.remove('main-nav--hidden');

  const menuTitle = mobileMenu.querySelector('.mobile-menu__title');
  if (menuTitle) menuTitle.textContent = 'Menu';

  const backButton = mobileMenu.querySelector('.mobile-menu__back');
  if (backButton) backButton.remove();
}

function initMobileMenu() {
  if (window.innerWidth >= MOBILE_BREAKPOINT) return;

  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenuClose  = document.getElementById('mobile-menu-close');
  const mobileMenu       = document.getElementById('mobile-menu');
  const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
  const body = document.body;

  if (!mobileMenuToggle || !mobileMenu) return;

  function openMenu() {
    mobileMenu.classList.add('mobile-menu--open');
    mobileMenuOverlay.classList.add('mobile-menu__overlay--active');
    body.classList.add('menu-open');
  }

  function closeMenu() {
    mobileMenu.classList.remove('mobile-menu--open');
    mobileMenuOverlay.classList.remove('mobile-menu__overlay--active');
    body.classList.remove('menu-open');
    resetPanelState(mobileMenu);
  }

  function showSubmenu(parentItem) {
    const submenu    = parentItem.querySelector('.first-level-sub-menu');
    const mainNav    = mobileMenu.querySelector('.mobile-menu__nav');
    const menuTitle  = mobileMenu.querySelector('.mobile-menu__title');
    const menuHeader = mobileMenu.querySelector('.mobile-menu__header');

    if (!submenu || !mainNav || !menuTitle) return;

    const parentLink   = parentItem.querySelector('a .dropdown-title');
    const submenuTitle = parentLink ? parentLink.textContent : 'Menu';

    mainNav.classList.add('main-nav--hidden');
    submenu.classList.add('submenu--active');
    menuTitle.textContent = submenuTitle;

    const ariaLabel  = mobileMenu.getAttribute('data-aria-text');
    const backButton = createBackButton(ariaLabel, () => resetPanelState(mobileMenu));
    menuHeader.insertBefore(backButton, menuTitle);
  }

  mobileMenuToggle.addEventListener('click', openMenu);

  if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', closeMenu);
  }

  if (mobileMenuOverlay) {
    mobileMenuOverlay.addEventListener('click', closeMenu);
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileMenu.classList.contains('mobile-menu--open')) {
      closeMenu();
    }
  });

  mobileMenu.querySelectorAll('.menu-item-has-children > a').forEach((item) => {
    item.addEventListener('click', (e) => {
      e.preventDefault();

      const dropdownTitle = e.target.closest('.dropdown-title');
      const arrowWrapper  = e.target.closest('.arrow-wrapper');

      if (dropdownTitle) {
        const linkHref = item.getAttribute('href');
        if (linkHref && linkHref !== '#') {
          closeMenu();
          window.location.href = linkHref;
          return;
        }
      }

      if (arrowWrapper || (!dropdownTitle && !arrowWrapper)) {
        showSubmenu(item.closest('.menu-item-has-children'));
      }
    });
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('.submenu-title a')) {
      e.preventDefault();
      resetPanelState(mobileMenu);
    }
  });

  mobileMenu.querySelectorAll('a:not(.menu-item-has-children > a):not(.submenu-title a)').forEach((item) => {
    item.addEventListener('click', closeMenu);
  });
}

function initMobileMegaMenu() {
  const mobileMenu = document.getElementById('mobile-menu');
  if (!mobileMenu) return;

  mobileMenu.querySelectorAll('.menu-item-has-children').forEach(function (item) {
    const megaContainer = item.querySelector(':scope > .ilabs-mega-menu-container');
    if (!megaContainer) return;

    const link = item.querySelector(':scope > a');
    if (!link) return;

    link.addEventListener('click', function (e) {
      if (window.innerWidth >= MOBILE_BREAKPOINT) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      openMegaPanel(megaContainer, link, mobileMenu);
    });
  });
}

// ----------------------------------------------------------------
// Open a mega-menu container as a full-height sub-panel
// ----------------------------------------------------------------
function openMegaPanel(container, trigger, mobileMenu) {
  resetPanelState(mobileMenu);

  const mainNav    = mobileMenu.querySelector('.mobile-menu__nav');
  const menuTitle  = mobileMenu.querySelector('.mobile-menu__title');
  const menuHeader = mobileMenu.querySelector('.mobile-menu__header');

  if (!mainNav || !menuTitle || !menuHeader) return;

  mainNav.classList.add('main-nav--hidden');
  container.classList.add('submenu--active');
  menuTitle.textContent = trigger.textContent.trim();

  const backButton = createBackButton('Wróć do menu', () => resetPanelState(mobileMenu));
  menuHeader.insertBefore(backButton, menuTitle);
}